export class ProcessoEntrevista {

  public Id: number;
  public Entrevista: string;
  public Ativo: boolean;
  constructor() {
    this.Id = 0;
    this.Entrevista = '';
  }
}
